
import React from 'react';
import { Row, Col } from 'react-bootstrap';
import styles from './announcements.module.scss';

const AnnouncementSection = () => {
  const imageUrl = 'https://dp-announcements.s3-ap-southeast-1.amazonaws.com/announcement.jpg';
  return (
    <div className={styles['info-wrapper']}>
      <Row>
        <Col lg="12" md="12">
          <img src={imageUrl}/>
        </Col>
      </Row>
    </div>
  )
}

export default AnnouncementSection;
